var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-input field"},[_c('input',{attrs:{"name":_vm.name,"placeholder":" ","readonly":_vm.readonly,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onInputChange}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73709b5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/text-input.vue
// module id = 1482
// module chunks = 0